export default __webpack_public_path__ + "c94b127a45691edca72e7139bf76c7fe.png";